import { Alert, Button, Form, Input, InputNumber, Radio } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '~/App/components/Container';
import Header from '~/App/components/Header';
import { useLoadingSetter } from '~/providers/LoadingProvider';
import { CashierTransactionType } from '~/types/CashierTransaction';
import message from '~/utils/message';
import StickyHeader from '../../../components/StickyHeader';
import { createCashierTransaction } from '../../api';

const CreateCashierTransaction = () => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const setLoading = useLoadingSetter();
  const onFinish = async (values: any) => {
    setError(null);
    setLoading(true);
    const { error, errorMsg } = await createCashierTransaction(values);
    setLoading(false);
    if (error) {
      setError(errorMsg);
      return;
    }
    navigate('/');
    message.success('Transaksi telah dibuat');
  };
  return (
    <Container>
      <StickyHeader>
        <Header title="Buat Transaksi Kasir" />
      </StickyHeader>
      <div style={{ padding: 16 }}>
        {error ? <Alert type="error" message={error} /> : null}
        <Form name="cashierTransaction" onFinish={onFinish} layout="vertical">
          <Form.Item label="Tipe" name="type">
            <Radio.Group>
              <Radio value={CashierTransactionType.Out}>Keluar</Radio>
              <Radio value={CashierTransactionType.In}>Masuk</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Jumlah"
            name="amount"
            rules={[{ required: true, message: 'Jumlah harus diisi' }]}
          >
            <InputNumber style={{ width: '100%' }} size="large" />
          </Form.Item>
          <Form.Item
            label="Deskripsi"
            name="description"
            rules={[{ required: true, message: 'Deskripsi harus diisi' }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item style={{ marginTop: 40 }}>
            <Button type="primary" htmlType="submit" block size="large">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Container>
  );
};

export default CreateCashierTransaction;
